import { render } from "./NYFormSucceed.vue?vue&type=template&id=6ee24707&scoped=true"
import script from "./NYFormSucceed.vue?vue&type=script&lang=js"
export * from "./NYFormSucceed.vue?vue&type=script&lang=js"

import "./NYFormSucceed.vue?vue&type=style&index=0&id=6ee24707&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee24707"]])

export default __exports__